<div class="flex flex-col gap-12">
  <div class="flex flex-col gap-4">
    <h2 class="!m-0">Manage Apps</h2>

    @if (isProduction && (isLive$ | async) === false) {
      <pr-information-box theme="warn">
        <div
          class="flex flex-col items-center justify-between gap-2 md:flex-row"
        >
          <p class="!m-0">
            You are not yet approved for our production environment. To enable
            your apps to be used in the production environment, please contact
            the Principle Dental team.
          </p>
          <div>
            <button
              class="w-36"
              mat-flat-button
              color="primary"
              (click)="intercom.open()"
            >
              Contact Us
            </button>
          </div>
        </div>
      </pr-information-box>
    }

    @if (!isProduction) {
      <pr-information-box>
        <div
          class="flex flex-col items-center justify-between gap-2 md:flex-row"
        >
          <p class="!m-0">
            Once your integration is ready to be published, we will create a
            Partner Account in our production environment. Please contact the
            Principle Dental team to organise access.
          </p>
          <div>
            <button
              class="w-36"
              mat-flat-button
              color="primary"
              (click)="intercom.open()"
            >
              Contact Us
            </button>
          </div>
        </div>
      </pr-information-box>
    }

    <pr-app-list />
  </div>

  <div class="flex flex-col gap-4">
    <h2 class="!m-0">Test Accounts</h2>
    <pr-test-account-list />
  </div>

  <div class="flex flex-col gap-4">
    <h2 class="!m-0">Manage Users</h2>
    <pr-users routePrefix="users" [userCollection]="userCollection$ | async" />
  </div>
</div>
